const COLORS = {
  greyL1: '#fafafa',
  grey: '#f7f8fa',
  greyD1: '#e9ecef',
  greyD2: '#474747',
  white: '#fff',
};

export default COLORS; 